var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLiveTrafficMassTransit = function SvgLiveTrafficMassTransit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CA4E41",
    d: "M12.009 22.08c5.523 0 10-4.478 10-10 0-5.523-4.477-10-10-10s-10 4.477-10 10c0 5.522 4.477 10 10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.741 5.526h-2.25v1.848l.438-1.848h-2.697l-1 2.41v3.358h1.242v-.884H16.5v.884h1.241V7.937z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CA4E41",
    d: "M12.866 9.32a.455.455 0 1 0 0-.91.455.455 0 0 0 0 .91M12.322 7.713h2.16V6.321h-1.678z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CA4E41",
    d: "M16.17 6.32h-2.384l.705 1.393h2.161zM16.107 9.32a.455.455 0 1 0 0-.91.455.455 0 0 0 0 .91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CA4E41",
    d: "m16.759 12.008-2.053-4.973H9.938s-3.233.598-3.384.67c-.152.071-1.76 2.428-1.875 2.553-.116.125-.09 3.947-.116 4.25-.027.304.839 2.723.955 2.902.116.178 3.777 1.678 3.777 1.678l5.67-.205s2.901-2.687 2.767-2.777c-.134-.089-.107-2.107-.196-2.17-.09-.062-.777-1.937-.777-1.937z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.01 8.07H7.687l-1.465 3.545v4.947h1.822v-1.304h2.973z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#CA4E41",
    d: "M11.706 11.294H7.822l.714-2.054h2.982zM8.625 13.66a.67.67 0 1 0 0-1.34.67.67 0 0 0 0 1.34"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.214 8.07h4.116l1.465 3.545v4.947h-1.822v-1.304H11z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#CA4E41",
    d: "M9.893 11.294h4.313L13.49 9.24h-3.268zM13.402 13.66a.67.67 0 1 0 0-1.34.67.67 0 0 0 0 1.34"
  })));
};
export default SvgLiveTrafficMassTransit;